class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerJm = document.getElementById('jmProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
      countContainerJm.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (window.yotpo) {
          yotpo.initWidgets();
        }
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const countjm = new DOMParser().parseFromString(html, 'text/html').getElementById('jmProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const jmcontainer = document.getElementById('jmProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    jmcontainer.innerHTML = countjm;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) {
        return;
      }
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetFilterFormBlog extends HTMLElement {
  constructor() {
    super();
    this.blogsURL = this.getAttribute('data-url');
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const articleFacetForm = this.querySelector('form');
    if (articleFacetForm) {
      articleFacetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    // const facetWrapper = this.querySelector('#ArticleFacetsWrapperDesktop');
    // if (facetWrapper) {
    //   facetWrapper.addEventListener('keyup', onKeyUpEscape);
    // }

    // FacetFilterFormBlog.setListeners();
  }

  onSubmitForm(searchParams, event) {
    FacetFilterFormBlog.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filter-form-blog form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.getTagged(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.getTagged(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.getTagged(form));
        }
      });
      // this.onSubmitForm(forms.join('&'), event);
      this.onSubmitForm(forms, event);
    }
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  getTagged(form) {
    if (form) {
      let checkboxes = form.querySelectorAll('[type="checkbox"]:checked');
      if (checkboxes.length > 0) {
        return Array.from(checkboxes)
          .map((checkbox) => checkbox.value)
          .filter((value) => value)
          .join('+');
      } else {
        return '';
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFilterFormBlog.searchParamsInitial;
      if (searchParams === FacetFilterFormBlog.searchParamsPrev) return;
      FacetFilterFormBlog.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('article-grid').dataset.id,
      },
    ];
  }

  static getURL(event) {
    let URL = window.location.pathname;

    if (URL.includes('tagged')) {
      URL = URL.substring(0, URL.indexOf('tagged'));
    } else if (URL.includes('pages')) {
      URL = URL.substring(0, URL.indexOf('pages'));
      let parentElm = event.target.closest('#blog_lists')?.querySelector('#article-grid');

      URL = window.location.origin + '/blogs/' + parentElm?.dataset.url;
    } else {
      URL = URL.substring(0, URL.lastIndexOf('/'));
    }

    return URL;
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFilterFormBlog.searchParamsPrev = searchParams;

    const sections = FacetFilterFormBlog.getSections();
    const countContainer = document.getElementById('ArticleCount');
    const countContainerDesktop = document.getElementById('ArticleCountDesktop');
    const loadingSpinners = document.querySelectorAll('.article-facets-container .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    // document.getElementById('ArticleGridContainer').classList.add('loading');

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    sections.forEach((section) => {
      const getUrl = this.getURL(event);
      let url = `${getUrl}/tagged/${searchParams}`;
      if (getUrl.includes('tagged')) {
        url = `${getUrl}${searchParams}`;
      }
      if (searchParams == '' || searchParams == undefined) {
        url = `${window.location.pathname}`;
      }

      const filterDataUrl = (element) => element.url === url;
      FacetFilterFormBlog.filterData.some(filterDataUrl)
        ? FacetFilterFormBlog.renderSectionFromCache(filterDataUrl, event)
        : FacetFilterFormBlog.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFilterFormBlog.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    let form = event.target.closest('form');
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFilterFormBlog.filterData = [...FacetFilterFormBlog.filterData, { html, url }];
        FacetFilterFormBlog.renderFilters(html, event);
        FacetFilterFormBlog.renderArticleGridContainer(html);
        // FacetFilterFormBlog.renderArticleCount(html);
        FacetFilterFormBlog.prepareActiveTag(form);

        if (window.yotpo) {
          yotpo.initWidgets();
        }

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    let form = event.target.closest('form');
    const html = FacetFilterFormBlog.filterData.find(filterDataUrl).html;
    FacetFilterFormBlog.renderFilters(html, event);
    FacetFilterFormBlog.renderArticleGridContainer(html);
    // FacetFilterFormBlog.renderArticleCount(html);
    FacetFilterFormBlog.prepareActiveTag(form);

    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static getTaggedWithoutValid(form) {
    if (form) {
      let checkboxes = form.querySelectorAll('[type="checkbox"]:not([name="auto_checked"]):checked');
      if (checkboxes.length > 0) {
        return Array.from(checkboxes)
          .map((checkbox) => checkbox.value)
          .filter((value) => value);
        // return true;
      } else {
        return false;
      }
    } else {
      return '';
    }
  }

  static prepareActiveTag(form) {
    let activeTags = FacetFilterFormBlog.getTaggedWithoutValid(form);
    let html = ``;

    if (activeTags) {
      document.getElementById('article-grid').classList.add('filtered');
      activeTags.forEach((activeTag) => {
        let activeTagElm = form.querySelector(`[value="${activeTag}"]`);
        html += `<facet-remove-blog data-slug="${activeTag}" class="remove-blog-facet">
                    <a href="javascript:void(0);" class="active-facets__button active-facets__button--light" role="button">
                      <span class="active-facets__button-inner btn btn-secondary btn-ring btn-sm">
                        ${activeTagElm.closest('label').innerText}
                        <div class="text-gray-500">
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 16 16">
                            <path d="M3.16602 3.16663L12.8327 12.8333M12.8327 3.16663L3.16602 12.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                            </path>
                          </svg>
                        </div>
                        <span class="visually-hidden">Remove filter</span>
                      </span>
                    </a>
                  </facet-remove-blog>`;
      });
      form.querySelector('.active-facets_blog').innerHTML = html;
      form.querySelector('facet-remove-clearall').classList.remove('hidden');
      // form.querySelector('.active-facets-desktop').insertAdjacentHTML('beforeend', html);
    } else {
      form.querySelector('.active-facets_blog').innerHTML = '';
      form.querySelector('facet-remove-clearall').classList.add('hidden');
      document.getElementById('article-grid').classList.remove('filtered');
    }
  }

  static renderArticleGridContainer(html) {
    document.getElementById('article-grid').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('article-grid').innerHTML;

    document
      .getElementById('article-grid')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderArticleCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ArticleCount').innerHTML;
    const container = document.getElementById('ArticleCount');
    const containerDesktop = document.getElementById('ArticleCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.article-facets-container .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#ArticleFacetFiltersForm .js-filter, #ArticleFacetFiltersFormMobile .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#ArticleFacetFiltersForm .js-filter, #ArticleFacetFiltersFormMobile .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    // FacetFilterFormBlog.renderActiveFacets(parsedHTML);
    // FacetFilterFormBlog.toggleActiveFacets(false, event);
    // FacetFilterFormBlog.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFilterFormBlog.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFilterFormBlog.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) {
        return;
      }
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFilterFormBlog.toggleActiveFacets(true);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('ArticleFacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetSummary = target.querySelector('.mobile-facets__summary');
    const sourceSummary = source.querySelector('.mobile-facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetWrapElement = target.querySelector('.mobile-facets__details');
    const sourceWrapElement = source.querySelector('.mobile-facets__details');

    if (sourceWrapElement && targetWrapElement) {
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static toggleActiveFacets(toggle = true, event = null) {
    let form = event.target.closest('form');
    const activeFacetWrappers = form.querySelectorAll('.remove-blog-facet');
    if (activeFacetWrappers.length > 0) {
      form.querySelector('facet-remove-clearall').classList.remove('hidden');
    } else {
      form.querySelector('facet-remove-clearall').classList.add('hidden');
    }

    // activeFacetWrappers.forEach((activeFacetWrapper) => {
    //   activeFacetWrapper.classList.toggle('hidden', isHidden);
    // });
  }
}

FacetFilterFormBlog.filterData = [];
FacetFilterFormBlog.searchParamsInitial = window.location.search.slice(1);
FacetFilterFormBlog.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filter-form-blog', FacetFilterFormBlog);

class FacetRemoveBlog extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.uncheckFilter();
    });
  }
  uncheckFilter() {
    let uncheckedFilter = this.dataset.slug;
    this.form.querySelector('[value="' + uncheckedFilter + '"]').click();
    // this.form.submit();
    this.remove();
  }
}

customElements.define('facet-remove-blog', FacetRemoveBlog);

class FacetRemoveClearAll extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.clearButton = this.querySelector('.active-facets__button-remove');
    this.clearButton.addEventListener('click', this.handleClear.bind(this));
    this.clearButton.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.handleClear();
      }
    });
  }

  handleClear() {
    const checkboxes = this.form.querySelectorAll('input[type="checkbox"][name^="filter."]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    const activeFacetsContainer = this.form.querySelector('.active-facets_blog');
    if (activeFacetsContainer) {
      activeFacetsContainer.innerHTML = '';
    }

    this.classList.add('hidden');

    const articleGrid = document.getElementById('article-grid');
    if (articleGrid) {
      articleGrid.classList.remove('filtered');
    }

    // Trigger the filtering mechanism
    const facetFilterFormBlog = this.closest('facet-filter-form-blog');
    if (facetFilterFormBlog) {
      const event = new Event('input', { bubbles: true, cancelable: true });
      this.form.dispatchEvent(event);
    }
  }
}

customElements.define('facet-remove-clearall', FacetRemoveClearAll);
